import { render, staticRenderFns } from "./ShowIOrganisationsMemberShips.vue?vue&type=template&id=0826879c&"
import script from "./ShowIOrganisationsMemberShips.vue?vue&type=script&lang=js&"
export * from "./ShowIOrganisationsMemberShips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports